(function () {
  function initializeStickyCart(root) {
    const bar = root.querySelector('[data-nv-sticky-cart]');
    if (!bar || bar.dataset.initialized) return;
    const main = document.querySelector('product-info.nv-product-page');
    const form = main?.querySelector('product-form form[data-type="add-to-cart-form"]');
    const submit = form?.querySelector('button[name="add"]');
    if (!main || !form || !submit) return;
    bar.dataset.initialized = 'true';
    const barSubmit = bar.querySelector('[data-nv-sticky-submit]');
    const barPrice = bar.querySelector('[data-nv-sticky-price]');
    const showIfScrolled = () => {
      const shouldShow = submit.getBoundingClientRect().bottom < 0;
      if (shouldShow) {
        if (bar.hidden) {
          bar.hidden = false;
          requestAnimationFrame(() => bar.classList.add('is-visible'));
        }
      } else if (!bar.hidden) {
        bar.classList.remove('is-visible');
        bar.hidden = true;
      }
      barSubmit.disabled = submit.disabled;
    };
    const updateFromProduct = () => {
      const price = main.querySelector('[id^="price-"] .price:not(.price--on-sale) .price-item--regular, [id^="price-"] .price--on-sale .price-item--sale');
      if (price && barPrice) barPrice.textContent = price.textContent.trim();
      showIfScrolled();
    };
    barSubmit.addEventListener('click', () => {
      if (submit.disabled) return;
      form.requestSubmit(submit);
    });
    window.addEventListener('scroll', showIfScrolled, { passive: true });
    window.addEventListener('resize', showIfScrolled, { passive: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event?.data?.sectionId === main.dataset.section) requestAnimationFrame(updateFromProduct);
      });
    }
    updateFromProduct();
  }
  function start() { initializeStickyCart(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
